import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import React, { useState, useMemo, useEffect } from "react"
import {
  FaChevronLeft,
  FaChevronRight,
  FaEdit,
  FaFileImport,
  FaPlus,
  FaSave,
} from "react-icons/fa"
import { MdCancel, MdDelete } from "react-icons/md"
import {
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Input,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import Swal from "sweetalert2"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import { usePermissionData } from "AppContext"

const Category = () => {
  document.title = "Categories | Milano Jewelry"
  const { checkAccess } = usePermissionData()

  // State
  const [category, setcategory] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [editingCategory, seteditingCategory] = useState(null)
  const [searchText, setSearchText] = useState("")
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(10)

  const [loading, setLoading] = useState(false)

  /* ================= SAMPLE DATA ================= */
  useEffect(() => {
    getCategory()
  }, [])

  async function getCategory() {
    const APIdata = await fetchData(setLoading, "category")
    if (APIdata?.success) {
      setcategory(APIdata?.data)
    }
  }

  // Toggle modal
  const toggleModal = () => setModalOpen(!modalOpen)

  // Open modal for Edit
  const handleEdit = dept => {
    seteditingCategory(dept)
    toggleModal()
  }

  // Save Category
  const handleSave = async () => {
    if (!editingCategory?.categoryName?.trim()) {
      Swal.fire({ title: "Category name is required", icon: "warning" })
      return
    }
    if (editingCategory?.id) {
      const APIdata = await FetchPutData(
        setLoading,
        "category",
        editingCategory?.id,
        editingCategory
      )
      if (APIdata?.data?.success) {
        setModalOpen(false)
        Swal.fire({
          title: "Category Updated Successfully",
          text: APIdata?.data?.message,
          icon: "success",
        })
        setTimeout(() => {
          getCategory()
        }, 1500)
      } else {
        Swal.fire({
          title: "Error Adding Category",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    } else {
      const APIdata = await FetchPostData(
        setLoading,
        "category",
        editingCategory
      )
      if (APIdata?.data?.success) {
        setModalOpen(false)
        Swal.fire({
          title: "Category Added Successfully",
          text: APIdata?.data?.message,
          icon: "success",
        })
        setTimeout(() => {
          getCategory()
        }, 1500)
      } else {
        Swal.fire({
          title: "Error Adding Category",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    }
  }

  const handleDelete = async item => {
    const confirm = await Swal.fire({
      title: "Are you Sure?",
      text: `you want to Delete this ${item?.categoryName} Category`,
      icon: "warning",
      showCancelButton: true,
    })

    if (!confirm.isConfirmed) {
      return
    }
    const APIdata = await FetchDeleteData(setLoading, "category", item?.id)
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Category Deleted Successfully",
        text: APIdata?.data?.message,
        icon: "success",
      })
      setTimeout(() => {
        getCategory()
      }, 1500)
    } else {
      Swal.fire({
        title: "Error deleting Role",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  // Filtered & paginated category
  const filteredDepts = useMemo(
    () =>
      category.filter(d =>
        d?.categoryName?.toLowerCase().includes(searchText.toLowerCase())
      ),
    [category, searchText]
  )

  const totalPages = Math.ceil(filteredDepts.length / perPage)
  const paginatedDepts = filteredDepts.slice(
    (page - 1) * perPage,
    page * perPage
  )

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb title="Settings" breadcrumbItem="category" />
      <Card>
        <CardBody>
          {/* ===== FILTER BAR ===== */}
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex gap-3">
              <select
                className="form-select"
                style={{ width: "100px" }}
                value={perPage}
                onChange={e => {
                  setPerPage(Number(e.target.value))
                  setPage(1)
                }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>

              <Input
                placeholder="Search..."
                value={searchText}
                onChange={e => {
                  setSearchText(e.target.value)
                  setPage(1)
                }}
              />
            </div>

            {checkAccess(8, "add") && (
              <Button
                className="btn-blue"
                onClick={() => {
                  toggleModal(), seteditingCategory({})
                }}
              >
                <FaPlus className="me-1" />
                Add
              </Button>
            )}
          </div>

          <Table bordered responsive hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>Category Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedDepts.length > 0 ? (
                paginatedDepts.map((dept, index) => (
                  <tr key={dept.id}>
                    <td>{(page - 1) * perPage + index + 1}</td>
                    <td>{dept.categoryName}</td>
                    <td>
                      {checkAccess(8, "edit") && (
                        <Button
                          color="success"
                          className="me-2"
                          onClick={() => handleEdit(dept)}
                        >
                          <FaEdit />
                        </Button>
                      )}
                      {checkAccess(8, "delete") && (
                        <Button
                          color="danger"
                          onClick={() => handleDelete(dept)}
                        >
                          <MdDelete />
                        </Button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="text-center">
                    No category found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* ===== PAGINATION ===== */}
          <div className="d-flex justify-content-between">
            <span className="align-self-center">
              Page {page} of {totalPages || 1}
            </span>
            {/* ===== PAGINATION ===== */}
            <div className="d-flex justify-content-center align-items-center gap-2 ">
              {/* Previous */}
              <Button
                disabled={page === 1}
                onClick={() => setPage(prev => prev - 1)}
                className="btn-blue"
              >
                <FaChevronLeft />
              </Button>

              {/* Page Numbers (Show 5 at a time) */}
              {(() => {
                const pageNumbers = []
                const maxVisiblePages = 5

                let startPage = Math.max(
                  1,
                  page - Math.floor(maxVisiblePages / 2)
                )

                let endPage = startPage + maxVisiblePages - 1

                if (endPage > totalPages) {
                  endPage = totalPages
                  startPage = Math.max(1, endPage - maxVisiblePages + 1)
                }

                for (let i = startPage; i <= endPage; i++) {
                  pageNumbers.push(
                    <Button
                      key={i}
                      color={page === i ? "primary" : "light"}
                      onClick={() => setPage(i)}
                    >
                      {i}
                    </Button>
                  )
                }

                return pageNumbers
              })()}

              {/* Next */}
              <Button
                disabled={page === totalPages || totalPages === 0}
                onClick={() => setPage(prev => prev + 1)}
                className="btn-blue"
              >
                <FaChevronRight />
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>

      {/* Add/Edit Modal */}
      <Modal isOpen={modalOpen} centered>
        <ModalHeader toggle={toggleModal}>
          {editingCategory?.id ? "Edit Category" : "Add Category"}
        </ModalHeader>
        <ModalBody>
          <Form>
            <Label>Category Name</Label>
            <Input
              type="text"
              value={editingCategory?.categoryName || ""}
              onChange={e =>
                seteditingCategory(prev => ({
                  ...prev,
                  categoryName: e.target.value.replace(/^\s+/, ""),
                }))
              }
            />
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button className="btn-blue" onClick={handleSave}>
            <FaSave /> Save
          </Button>{" "}
          <Button color="secondary" onClick={toggleModal}>
            <MdCancel /> Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default Category
